import React from 'react'; // eslint-disable-line
import { getQueryVar } from '../../query/getQueryVar';
import { setsessionId, setToken } from '../../token/setToken';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.getAndSetToken();
    }

    getAndSetToken = () => {
        const queryToken = getQueryVar('jwt');
        const sessionId = getQueryVar('sessionId');
        if (queryToken != null) {
            if (typeof (Storage) !== 'undefined') {
                localStorage.clear();
                localStorage.setItem('AuthToken', queryToken);
                setToken();
                if (sessionId != null) {
                    localStorage.setItem('SessionId', sessionId);
                    setsessionId();
                }
                this.redirect();
            }
        }
    }

    setTokenToLocalStorage = (tokenValue) => {
        localStorage.setItem('AuthToken', tokenValue);
    }

    redirect = () => {
        const projectId = getQueryVar('projectId');
        if (projectId?.length !== 36) {
            this.props.history.push('/');
        } else {
            this.props.history.push(`/projects/${projectId}/general-info`);
        }
    }

    render() {
        return (
            <div />
        );
    }
}

export default Login;
